import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useContext, createContext, useReducer } from 'react';
import { getHCPCSdiagallowed } from '@mummssoftware/utils/hcpcsUtils';
import { GlobalContext } from '../GlobalContext';
import { SET_HCPCS_CHOICE, SET_HCPCS_DURATION, SET_SHOW_HCPCS, SET_HCPCS_ERROR, DELETE_HCPCS_CHOICE, DELETE_ICD_CODE, ADD_ICD_CODE, SET_ICD_SECTION, SET_HCPCS_CODE_MAP, RESET_HCPCS, RECORD_DATA, SHOW_HCPCS_LOADER, SET_SUBMIT_HCPCS_ERROR, DISABLE_HCPCS_MENU, ADD_SAVED_ICD_CODE } from './constants';
const initialState = {
  hcpcsDuration: null,
  hcpcsChoices: [],
  showHCPCS: false,
  hcpcsNameSelected: null,
  hcpcsMapping: null,
  hcpcsError: false,
  icdSection: {},
  icdCodes: null,
  icdCodeNames: {},
  hcpcsCodesMap: {},
  recordData: false,
  showHCPCSLoader: false,
  submithcpcsError: false,
  disabledHCPCSMenu: false
};
const initHCPCSGlobalContext = {
  hcpcsDuration: null,
  hcpcsChoices: [],
  showHCPCS: false,
  hcpcsNameSelected: null,
  hcpcsMapping: null,
  hcpcsError: false,
  icdCodes: null,
  icdSection: {},
  hcpcsPermission: null,
  icdCodeNames: {},
  hcpcsCodesMap: {},
  recordData: false,
  showHCPCSLoader: false,
  submithcpcsError: false,
  disabledHCPCSMenu: false
};
export const HCPCSGlobalContextReducer = (state, action) => {
  let newState = _objectSpread({}, state);

  switch (action.type) {
    case SET_HCPCS_DURATION:
      if (action.payload) {
        const choice = action.payload;
        const {
          key,
          duration
        } = choice;

        if (newState.hcpcsDuration) {
          newState.hcpcsDuration[key] = duration;
        } else {
          newState.hcpcsDuration = {};
          newState.hcpcsDuration[key] = duration;
        }
      }

      break;

    case SET_SHOW_HCPCS:
      newState.showHCPCS = action.payload;
      break;

    case SET_HCPCS_ERROR:
      newState.hcpcsError = action.payload;
      break;

    case RECORD_DATA:
      newState.recordData = action.payload;
      break;

    case SHOW_HCPCS_LOADER:
      newState.showHCPCSLoader = action.payload;
      break;

    case DISABLE_HCPCS_MENU:
      newState.disabledHCPCSMenu = action.payload;
      break;

    case SET_SUBMIT_HCPCS_ERROR:
      newState.submithcpcsError = action.payload;
      break;

    case SET_HCPCS_CODE_MAP:
      if (action.payload) {
        const choice = action.payload;
        const {
          key,
          codes
        } = choice;
        newState.hcpcsCodesMap[key] = codes;
      }

      break;

    case SET_ICD_SECTION:
      if (action.payload) {
        const choice = action.payload;
        const {
          key,
          codes
        } = choice;
        newState.icdSection[key] = codes;
      }

      break;

    case ADD_ICD_CODE:
      if (action.payload) {
        const choice = action.payload;
        const {
          key,
          icdCode
        } = choice;

        if (newState.icdCodes) {
          if (newState.icdCodes[key]) {
            if (newState.icdCodes[key][icdCode]) {
              newState.icdCodes[key][icdCode] = ++newState.icdCodes[key][icdCode];
            } else {
              newState.icdCodes[key][icdCode] = 1;
            }
          } else {
            newState.icdCodes[key] = {};
            newState.icdCodes[key][icdCode] = 1;
          }
        } else {
          newState.icdCodes = {};
          newState.icdCodes[key] = {};
          newState.icdCodes[key][icdCode] = 1;
        }

        if (newState.icdCodeNames[key]) {
          newState.icdCodeNames[key] = [...newState.icdCodeNames[key], icdCode];
        } else {
          newState.icdCodeNames[key] = [icdCode];
        }
      }

      break;

    case ADD_SAVED_ICD_CODE:
      if (action.payload) {
        const choice = action.payload;
        const {
          key,
          icdCode
        } = choice;

        if (newState.icdCodes) {
          if (newState.icdCodes[key]) {
            if (newState.icdCodes[key][icdCode]) {
              newState.icdCodes[key][icdCode] = 1;
            } else {
              newState.icdCodes[key][icdCode] = 1;
            }
          } else {
            newState.icdCodes[key] = {};
            newState.icdCodes[key][icdCode] = 1;
          }
        } else {
          newState.icdCodes = {};
          newState.icdCodes[key] = {};
          newState.icdCodes[key][icdCode] = 1;
        }

        if (newState.icdCodeNames[key]) {
          if (newState.icdCodeNames[key].includes(icdCode)) {// do nothing
          } else {
            newState.icdCodeNames[key] = [...newState.icdCodeNames[key], icdCode];
          }
        } else {
          newState.icdCodeNames[key] = [icdCode];
        }
      }

      break;

    case DELETE_ICD_CODE:
      if (action.payload) {
        const choice = action.payload;
        const {
          key,
          icdCode,
          index
        } = choice;

        if (newState.icdCodes) {
          if (newState.icdCodes[key] && newState.icdCodes[key][icdCode]) {
            if (newState.icdCodes[key][icdCode] === 1) {
              delete newState.icdCodes[key][icdCode];
            } else {
              newState.icdCodes[key][icdCode] = --newState.icdCodes[key][icdCode];
            }
          } else if (newState.icdCodes[key]) {// do nothing
          } else if (newState.icdCodes) {// do nothing
          }
        }

        if (Object.keys(newState.icdSection).length) {
          const array = newState.icdSection[key];
          const section = [...array];
          const updatedSection = section.map((x, i) => {
            if (i === index) {
              return _objectSpread(_objectSpread({}, x), {}, {
                hide: true
              });
            }

            return x;
          });
          newState.icdSection[key] = updatedSection;
        } // remove from icdCodeNames


        if (newState.icdCodeNames[key]) {
          const arr = newState.icdCodeNames[key];
          const indexDup = arr.findIndex(x => x === icdCode);
          const newArr = arr.filter((x, i) => i !== indexDup);
          newState.icdCodeNames[key] = newArr;
        }
      }

      break;

    case DELETE_HCPCS_CHOICE:
      {
        const key = action.payload;

        if (newState.hcpcsMapping) {
          delete newState.hcpcsMapping[key];
          newState.hcpcsChoices = Object.values(newState.hcpcsMapping);
        }

        if (newState.hcpcsDuration) {
          delete newState.hcpcsDuration[key];
        }

        if (newState.icdSection && newState.icdCodes && newState.icdCodeNames) {
          delete newState.icdSection[key];
          delete newState.icdCodes[key];
          delete newState.icdCodeNames[key];
        }

        if (newState.hcpcsCodesMap[key]) {
          delete newState.hcpcsCodesMap[key];
        }

        if (newState.hcpcsMapping) {
          const {
            hcpcsMapping
          } = newState; // error only if not HCPCS left

          const hcpcsKeys = hcpcsMapping && Object.keys(hcpcsMapping);

          if (hcpcsKeys && hcpcsKeys.length < 1) {
            newState.hcpcsError = action.payload;
          }
        }

        newState.disabledHCPCSMenu = false;
      }
      break;

    case SET_HCPCS_CHOICE:
      // eslint-disable-next-line no-lone-blocks
      {
        if (action.payload) {
          const choice = action.payload;
          const hcpcsName = choice.parentName ? `${choice.parentName} - ${choice.name}` : `${choice.name}`;
          const {
            key
          } = choice;
          newState.hcpcsNameSelected = {
            hcpcsName,
            key
          };
          newState.hcpcsError = false;

          if (newState.hcpcsMapping) {
            newState.hcpcsMapping[key] = _objectSpread(_objectSpread({}, choice), {}, {
              visible: true
            });
          } else {
            newState.hcpcsMapping = {};
            newState.hcpcsMapping[key] = _objectSpread(_objectSpread({}, choice), {}, {
              visible: true
            });
          }

          newState.hcpcsChoices = Object.values(newState.hcpcsMapping);
        }
      }
      break;

    case RESET_HCPCS:
      // eslint-disable-next-line no-lone-blocks
      {
        newState.hcpcsDuration = null;
        newState.hcpcsChoices = [];
        newState.showHCPCS = false;
        newState.hcpcsNameSelected = null;
        newState.hcpcsMapping = null;
        newState.hcpcsError = false;
        newState.submithcpcsError = false;
        newState.icdCodes = null;
        newState.icdCodeNames = {};
        newState.icdSection = {};
        newState.hcpcsCodesMap = {};
        newState.disabledHCPCSMenu = false;
        newState.recordData = false;
      }
      break;

    default:
      newState = state;
      break;
  }

  return newState;
};
export const HCPCSGlobalContext = /*#__PURE__*/createContext(initHCPCSGlobalContext);
export const HCPCSGlobalContextProvider = ({
  children,
  keycloak,
  agency,
  patient
}) => {
  const [{
    hcpcsDuration,
    hcpcsChoices,
    showHCPCS,
    hcpcsNameSelected,
    hcpcsMapping,
    hcpcsError,
    icdCodes,
    icdSection,
    icdCodeNames,
    hcpcsCodesMap,
    recordData,
    showHCPCSLoader,
    submithcpcsError,
    disabledHCPCSMenu
  }, dispatch] = useReducer(HCPCSGlobalContextReducer, initialState);
  const {
    editingPastVisit,
    appVisit
  } = useContext(GlobalContext);
  const [hcpcsPermission, setHCPCSPermission] = useState(null); // getHCPCSdiagsearch(keycloak, agency, 'G30');

  const getHCPCSDiagallowed = async () => {
    if (!hcpcsPermission) {
      if (patient && editingPastVisit && agency) {
        const permissions = await getHCPCSdiagallowed(keycloak, agency, patient === null || patient === void 0 ? void 0 : patient.patientNumber, patient === null || patient === void 0 ? void 0 : patient.id, // accommodating for 2 visit types
        editingPastVisit.roleshortname || editingPastVisit.careProviderRole, editingPastVisit.effectivedatetime || editingPastVisit.starteventdatetime);

        if (!(permissions instanceof Response) && !permissions.hint && permissions.length) {
          setHCPCSPermission(permissions[0]);
        }
      }
    }
  };

  const resetHCPCSPerms = () => setHCPCSPermission(null);

  useEffect(() => {
    getHCPCSDiagallowed();
  }, [editingPastVisit, patient, hcpcsPermission]);
  useEffect(() => {
    if (hcpcsMapping && !Object.keys(hcpcsMapping).length && submithcpcsError) {
      dispatch({
        type: SET_SUBMIT_HCPCS_ERROR,
        payload: false
      });
    }
  }, [hcpcsMapping && Object.keys(hcpcsMapping)]);
  return /*#__PURE__*/React.createElement(HCPCSGlobalContext.Provider, {
    value: {
      hcpcsDuration,
      hcpcsChoices,
      showHCPCS,
      hcpcsPermission,
      hcpcsNameSelected,
      hcpcsMapping,
      hcpcsError,
      icdCodes,
      icdSection,
      icdCodeNames,
      hcpcsCodesMap,
      recordData,
      showHCPCSLoader,
      submithcpcsError,
      disabledHCPCSMenu,
      resetHCPCSPerms,
      dispatchHCPCS: dispatch
    }
  }, children);
};
export default HCPCSGlobalContextProvider;